<template>
    <common></common>
</template>
<script>
import common from './common.vue';

export default {
    name: 'commercialInvoiceEdit',
    components: {
        common,
    },
};
</script>
